import { render, staticRenderFns } from "./ReviewListBar.vue?vue&type=template&id=4fd9b598&scoped=true&"
import script from "./ReviewListBar.vue?vue&type=script&lang=js&"
export * from "./ReviewListBar.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListBar.vue?vue&type=style&index=0&id=4fd9b598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd9b598",
  null
  
)

export default component.exports